<template lang="pug" id="rich_text_message_attachments">
.attachments
    .message-attachment(v-for="(attachment, index) in attachments"
                                :key="index")
        asset-message(v-if="isAsset(attachment)"
                    :message="attachment.asset"
                    :imgAltText="imgAltText")
        file-message(v-else-if="isFile(attachment)"
                :senderType="senderType",
                :inWebchat="inWebchat"
                :message="attachment"
                :imgAltText="imgAltText"
                @link="$emit('link', $event)")
        document(v-else-if="isDocument(attachment)",
            :senderType="senderType",
            :attachment="attachment"
            :inWebchat="inWebchat"
            :url="attachment.url.link"
            @link="$emit('link', $event)")
        error-attachment(v-else :attachment="attachment")
        .attachment-name(v-if="shouldShowName(attachment)") {{ attachment.file.name }}
</template>

<script>

import get from 'lodash/get';
import AssetMessage from './AssetMessage.vue';
import FileMessage from './FileMessage.vue';
import Document from './Document.vue';
import ErrorAttachment from './ErrorAttachment.vue';

import { is } from '../MessageUtils';
import { IconsWithTypes } from '../../../helpers/docIcon';

export default {
  name: 'richTextMessageAttachments',
  props: {
    attachments: Array,
    inWebchat: { required: true, type: Boolean },
    senderType: { required: true, type: String },
    imgAltText: { required: true, type: String },
  },
  methods: {
    isDocument(attachment) {
      return is(attachment, 'document');
    },
    isFile(attachment) {
      return is(attachment, 'file');
    },
    isAsset(attachment) {
      return is(attachment, 'asset');
    },
    shouldShowName(attachment) {
      // IconsWithTypes contains all the "document" mime types that we support.
      // Mime types are the most reliable way to check for a file type.
      return !!IconsWithTypes[get(attachment, 'file.mime')];
    },
  },
  components: {
    AssetMessage,
    FileMessage,
    Document,
    ErrorAttachment,
  },
};
</script>

<style lang="scss" scoped>
.attachment-name {
  font-size: 12px;
  padding: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
</style>
